import { useContext } from 'react';
import { Table, TableRow, TableHead, TableBody, TableCell, TableFooter, Typography } from '@material-ui/core';
import { referenceDataContext } from '../ReferenceDataContext';
import Moment from 'react-moment';
import { DeleteIconButton, EditIconButton } from 'components';



let Results = () => {
    let service = useContext(referenceDataContext);


    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Key</TableCell>
                    <TableCell>Created</TableCell>
                    <TableCell>Updated</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {service.referenceData
                    .map((refData, index) =>
                        <TableRow hover key={refData.id}>
                            <TableCell>{refData.key}</TableCell>
                            <TableCell>
                                {refData.createdBy}&nbsp;&middot;&nbsp;<Moment date={refData.createdOn} format="LL" />
                            </TableCell>
                            <TableCell>
                                {refData.lastUpdatedBy}&nbsp;&middot;&nbsp;<Moment date={refData.lastUpdatedOn} format="LL" />
                            </TableCell>
                            <TableCell align="right">
                                <EditIconButton link={`/admin/referenceDataDetail/${refData.id}`} />
                                <DeleteIconButton onClick={() => service.deleteReferenceData(refData.id)} />
                            </TableCell>
                        </TableRow>
                    )}
            </TableBody>
            {service.referenceData.length === 0 &&
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={4}>
                            <Typography variant="subtitle2">No reference data found</Typography>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            }
        </Table>
    )
}

export default Results;